import React, { FC } from 'react';
import {
  createStyles,
  Theme,
  makeStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ProductTableItem, { ProductModel } from './ProductTableItem';
import TitleTableItem, { TitleModel } from './TitleTableItem';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

interface ProductTableProps {
  models?: Array<TitleModel | ProductModel>;
  onProductClick?: (product: any) => void;
}

const ProductTable: FC<ProductTableProps> = (props) => {
  const theme = createMuiTheme();
  const classes = useStyles(theme);

  if (props?.models === undefined || props?.models.length === 0) return <div />;

  const listRows = props?.models.map((model) => {
    if (model.type === 'product') {
      return (
        <ProductTableItem model={model} onProductClick={props?.onProductClick} />
      );
    } if (model.type === 'title') {
      return <TitleTableItem model={model} />;
    }
    return null;
  });

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="main mailbox folders" />
      {listRows}
    </div>
  );
};

export default ProductTable;
